import { Heading, VStack, Box, HStack, useBreakpointValue, FormControl, Text, Switch, Spinner, Center } from "@chakra-ui/react";
import Layout from "../components/layouts/main";
import { motion } from "framer-motion";
import useTotalMarks from "../hooks/useTotalMarks";
import InfoBlock from "../components/home/infoBlock";
import PieChart from "../components/charts/PieChart";
import useCurrentBlock from "../hooks/useCurrentBlock";
import useLatestBlock from "../hooks/useLatestBlock";
import CountUp from 'react-countup';
import DailyTop100ByMarks from "../components/dailyTop100ByMarks/DailyTop100ByMarks";
import WeeklyReport from "../components/WeeklyReport";
import useFetchReportDates from "../hooks/useFetchReportDates";
import MarksByProjects from "../components/MarksByProjects";
import { useState } from "react";

const MotionHeading = motion(Heading);

const HomePage = () => {
	const { totalMarks, totalAddresses } = useTotalMarks();
	const isMobile = useBreakpointValue({ base: true, md: false });
	const { blockNumber, loading, error } = useCurrentBlock();
	const { blockNumberLastest } = useLatestBlock();
	const { reportDates, loading: weeklyReportLoading, error: weeklyReportError } = useFetchReportDates();
	const [marksByUser, setMarksByUser] = useState(true);

	const getReport = () => {
		// Find the last report with a non-empty weekly_increase_report
		const lastReport = reportDates
			.slice() // Create a shallow copy to avoid mutating the original array
			.reverse() // Reverse the array to check from the last report to the first
			.find((item) => item.weekly_increase_report && item.weekly_increase_report.length > 0);
		return lastReport;
	};

	const report = getReport();
	const percentage = blockNumberLastest ? parseFloat((blockNumber / blockNumberLastest * 100).toFixed(2)) : 0;

	const handleSwitchChange = () => {
		setMarksByUser(!marksByUser);
	}

	return (
		<Layout>
			<Box padding={!isMobile ? 4 : 0}>
				<VStack spacing={8} align="center">
					<MotionHeading
						fontSize="clamp(1.5em, 2.8vw, 2.4em)"
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 1 }}
						textAlign={"center"}
						m={!isMobile ? 6 : 1}
					>
						Scroll Marks Distribution
					</MotionHeading>

					<HStack
						spacing={!isMobile ? 6 : 2}
						wrap="wrap"
						justify="center"
						textAlign="center"
					>
						<InfoBlock label="Total addresses" value={<CountUp start={totalAddresses > 0 ? totalAddresses - 10 : totalAddresses} end={totalAddresses} />} isMobile={isMobile} />
						<InfoBlock label="Total marks" value={<CountUp start={totalMarks > 0 ? totalMarks - 10 : totalMarks} end={totalMarks} />} isMobile={isMobile} />
						{!isMobile && <InfoBlock
							label="Sync Progress"
							note={'%'}
							value={<CountUp end={percentage} decimals={2} />}
							isMobile={isMobile}
						/>}
					</HStack>
					<Box minH={!isMobile ? "600px" : "auto"}>
						<FormControl display="flex" alignItems="center" justifyContent="center" pb={4}>
							<Text mr={2}>By Users</Text>
							<Switch
								id="mode-switch"
								isChecked={!marksByUser}
								onChange={handleSwitchChange}
								colorScheme="orange"
								// Styles to keep it looking always "on"
								sx={{
									'& .chakra-switch__track': {
										backgroundColor: 'orange.500' // Always orange
									},
									'&.chakra-switch--checked .chakra-switch__track': {
										backgroundColor: 'orange.500' // Checked state
									}
								}}
							/>
							<Text ml={2}>By Projects</Text>
						</FormControl>
						{marksByUser ? <PieChart /> : <MarksByProjects />}
					</Box>
				</VStack>
			</Box>
			{
				!weeklyReportLoading && !weeklyReportError ? (
					report ? (
						<WeeklyReport reportData={report} />
					) : (
						<Box textAlign="center" mt={4}>No report data available.</Box>
					)
				) : (
					<Center><Spinner /></Center>
				)
			}

			<DailyTop100ByMarks />

		</Layout >
	);
};

export default HomePage;
